/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICittaStoreLocationsNewData } from './citta-store-locations-new.data';
import { ICittaStoreLocationsNewProps } from './citta-store-locations-new.props.autogenerated';

export interface ICittaStoreLocationsNewViewProps extends ICittaStoreLocationsNewProps<ICittaStoreLocationsNewData> {}

/**
 *
 * CittaStoreLocationsNew component
 * @extends {React.PureComponent<ICittaStoreLocationsNewProps<ICittaStoreLocationsNewData>>}
 */
class CittaStoreLocationsNew extends React.PureComponent<ICittaStoreLocationsNewProps<ICittaStoreLocationsNewData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default CittaStoreLocationsNew;
